/* eslint-disable */
import React from "react";
import { TGeneralForm } from "@/features/clients/create/types";
import {Autocomplete, TextField} from "mui-rff";
import { useTranslation } from "react-i18next";
import {Grid, Popper} from "@mui/material";

const GeneralForm = ({ values, required, selectDataCountry, selectDataRegime }: TGeneralForm): any => {
    const { t } = useTranslation();

    // countries
    const valueCountry: any = selectDataCountry.find((country: any) => {
        return country.value === values.address_pais.value
    })

    // regimes
    const valueRegime: any = selectDataRegime.find((regime: any) => {
        return regime.value === values.cat_tax_regime_id.value
    });

    return (
        <Grid container spacing={2}>
            {/* <Grid item xs={12} md={12}>
                <Alert severity="info" sx={{ m: 0 }}>
                    {t("clients.general_helper_1")}
                    <br />
                    {t("clients.general_helper_2")}
                </Alert>
            </Grid> */}
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("clients.label_rfc")}
                    name="customers_rfc"
                    required={required.customers_rfc}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("clients.label_social_reason")}
                    name="customers_name"
                    required={required.customers_name}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <Autocomplete
                    defaultValue={valueRegime || {label: "601 - General de Ley Personas Morales" , value: "1"}}
                    value={values.cat_tax_regime_id}
                    placeholder={'Regimen fiscal'}
                    limitTags={1}
                    label={'Regimen fiscal'}
                    name="cat_tax_regime_id"
                    multiple={false}
                    required={true}
                    options={selectDataRegime}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable={true}
                    disableCloseOnSelect={false}
                    textFieldProps={{
                        InputLabelProps: { shrink: true }
                    }}
                    renderOption={(props: any, option: any, {selected}: any) => {
                        return <li {...props}>
                            {option.label}
                        </li>
                    }}
                    PopperComponent={({ style, ...props }) => {
                        return (
                            <Popper
                                {...props}
                                placement='bottom'
                                style={{ ...style, maxHeight: 50, zIndex: 999999 }} // width is passed in 'style' prop
                            />
                        )
                    }}
                />
            </Grid>

            <Grid item md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("clients.label_email")}
                    name="customers_email"
                    required={required.customers_email}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <Autocomplete
                    defaultValue={valueCountry || { label: 'México', value: '1' }}
                    value={values.address_pais}
                    placeholder={t("clients.placeholder_country")}
                    limitTags={1}
                    label={t("clients.label_country")}
                    name="address_pais"
                    multiple={false}
                    required={true}
                    options={selectDataCountry}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable={true}
                    disableCloseOnSelect={false}
                    textFieldProps={{
                        InputLabelProps: { shrink: true }
                    }}
                    renderOption={(props: any, option: any, {selected}: any) => {
                        return <li {...props}>
                            {option.label}
                        </li>
                    }}
                    PopperComponent={({ style, ...props }) => {
                        return (
                            <Popper
                                {...props}
                                placement='bottom'
                                style={{ ...style, maxHeight: 50, zIndex: 999999 }} // width is passed in 'style' prop
                            />
                        )
                    }}
                />
            </Grid>
            <Grid item md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("clients.label_tin")}
                    name="customers_num_regid_trib"
                    required={required.customers_num_regid_trib}
                />
            </Grid>
        </Grid>
    );
}

export default GeneralForm;
